
<div v-if="visible" ref="confirm" class="cp-confirm mobile">
  <div class="box-mask">
    <div class="box-container">
      <div class="box-content">
        您绑定的角色为<span class="emphsis">{{text}}</span>,绑定后将无法更换,确认绑定该角色吗?
      </div>
      <div class="button">
        <div class="bottom-item confirm" @click="handleAction('yes')"></div>
        <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
      </div>
      <Close is-mobile @close="handleAction('cancel')" class="close"></Close>
    </div>
  </div>
</div>
